import React, { useContext } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { NavLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import UserContext from '../../context/UserContext';
import { navLinks } from './__data';
import { useSnackbar } from 'notistack';


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function SwipeableTemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState(false);
  const { userData, setUserData } = useContext(UserContext);
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const { enqueueSnackbar } = useSnackbar();
  const logout = () => {
    setUserData({
      token: undefined,
      user: undefined
    });
    localStorage.setItem('auth-token', '');
    enqueueSnackbar('A bientôt =)', { variant: 'success' });
  }

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      role="presentation"
    >
      <List>
        {navLinks.map((link) => (
          <NavLink
            activeStyle={{
              fontWeight: 'bold',
              color: 'rgb(112, 195, 89)',
            }}
            className="MuiListItem-button"
            key={link.title}
            style={{color: 'black'}}
            to={link.path}
          >
            <ListItem
              button
              // key={link.title}
            >
              <ListItemText
                primary={link.title}
                style={{color: 'inherit', fontWeight: 'inherit', textTransform: 'uppercase'}}
              />
            </ListItem>
          </NavLink>
        ))}
      </List>
      <Divider />
      <List>
        {
          !userData.token ?
            <>
              <NavLink
                activeStyle={{
                  fontWeight: 'bold',
                  color: 'rgb(112, 195, 89)',
                }}
                className="MuiListItem-button"
                style={{color: 'black'}}
                to="/login"
              >
                <ListItem
                  button
                >
                  <ListItemText
                    primary={'Connexion'}
                    style={{color: 'inherit', fontWeight: 'inherit', textTransform: 'uppercase'}}
                  />
                </ListItem>
              </NavLink>
              <NavLink
                activeStyle={{
                  fontWeight: 'bold',
                  color: 'rgb(112, 195, 89)',
                }}
                className="MuiListItem-button"
                style={{color: 'black'}}
                to="/register"
              >
                <ListItem button>
                  <ListItemText
                    primary={'Créer un Compte'}
                    style={{color: 'inherit', fontWeight: 'inherit', textTransform: 'uppercase'}}
                  />
                </ListItem>
              </NavLink>
            </>
            :
            <>
              <NavLink
                activeStyle={{
                  fontWeight: 'bold',
                  color: 'rgb(112, 195, 89)',
                }}
                className="MuiListItem-button"
                style={{color: 'black'}}
                to="/my-account"
              >
                <ListItem button>
                  <ListItemText
                    primary={'Mon Compte'}
                    style={{color: 'inherit', fontWeight: 'inherit', textTransform: 'uppercase'}}
                  />
                </ListItem>
              </NavLink>
              <ListItem button>
                <ListItemText
                  activeStyle={{
                    fontWeight: 'bold',
                    color: 'rgb(112, 195, 89)',
                  }}
                  onClick={logout}
                  primary={'Déconnexion'}
                  style={{color: 'inherit', fontWeight: 'inherit', textTransform: 'uppercase'}}
                />
              </ListItem>
            </>
        }
      </List>
    </div>
  );

  return (
    <div>
      <React.Fragment key={'right'}>
        <IconButton
          aria-label="menu"
          className={classes.menuButton}
          color="inherit"
          edge="start"
          onClick={toggleDrawer('right', true)}
        >
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer
          anchor={'right'}
          onClose={toggleDrawer('right', false)}
          onOpen={toggleDrawer('right', true)}
          open={state['right']}
        >
          {list('right')}
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
}
